import React, { useState, useMemo, useEffect } from "react";
import { FaUserTie } from "react-icons/fa";
import { useGetStudentExitQuery } from "../../../redux/slice/students/studentseexit.js";
import Loader from "../../Loader/Loader.jsx";
import EmptyBox from "../../EmptyBox/EmptyBox.jsx";
import students from "../../../assetss/task_icons/students.jpg"


const StaffItem = ({ parent, index, onStatusChange }) => {
  // JSX for each teacher
  const [status, setStatus] = useState({
    is_active: parent.user.is_active,
    id: '',
  });

  return (
    <li className="flex justify-between gap-x-6 px-2 py-3 cursor-pointer  hover:bg-gray-200">
      <div className="flex min-w-0 gap-x-4">
        <h1>{index + 1}.</h1>
        {parent.user.image && parent.user.image !== "" ? (
          <img
            src={parent.user.image}
            alt="Teacher"
            className="h-12 w-12 flex-none rounded-full border object-cover"
          />
        ) : (
          <div className="w-12 border h-12 rounded-full border bg-gray-200 flex justify-center items-center">
            <FaUserTie className="text-3xl text-primary" />
          </div>
        )}
        <div className="min-w-0 flex-auto">
          <p className="text-sm font-semibold leading-6 ">
            {parent.user.first_name}
          </p>
          <p className="mt-1 truncate text-xs leading-5 ">
            {parent.user.last_name}
          </p>
        </div>

        <div className="min-w-0 flex-auto">
          <p className="text-sm font-semibold leading-6 ">
            {parent.sinf.name || " "}
          </p>
          <p className="mt-1 truncate text-xs leading-5 ">
            {parent.sinf.xona|| 'xona tanlanmagan'}
          </p>
        </div>
        <div className=" flex flex-col gap-1">
        <p className="">
          {parent?.deleted_log?.author?.first_name}
        </p>
        <p className="">
          {parent?.deleted_log?.author?.last_name}
        </p>
      </div>
      <div className=" flex flex-col gap-1">
        <p className="">
          Lavozim
        </p>
        <p className="">
          {parent?.deleted_log?.author?.full_type}
        </p>
      </div>
      <div className="flex flex-col">
        <p className="flex flex-col ">
          User Telfoni
        </p>
        <p className="flex flex-col ">
          {parent?.deleted_log?.author?.username}
        </p>
      </div>

      </div>
      <div className="flex gap-2 items-center">
        {/* <ViewParent object={parent} /> */}
        {/* <UpdateParent object={parent} /> */}
        {/* <DeleteParent ID={parent?.id} /> */}
      </div>
    </li>
  );
};

function StudentExit() {
  const [searchTerm, setSearchTerm] = useState("");
  const { data, isLoading, refetch } = useGetStudentExitQuery();
  const filteredStaff = useMemo(() => {
    // Computing the filtered teachers list
    if (searchTerm) {
      return data.deleted_students.filter(
        (parent) =>
          parent.user.first_name
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) ||
          parent.user.last_name.toLowerCase().includes(searchTerm.toLowerCase())
      );
    } else {
      return data?.deleted_students;
    }
  }, [data, searchTerm]);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  return (
    <div className="h-ful gap-3 col-span-12 sx:overflow-x-auto">
      <div className="rounded-lg shadow-md col-span-12 grid grid-cols-12 border h-[75vh] items-start overflow-hidden sx:w-max">
        <div className="col-span-12 flex items-center justify-between p-3">
          <div>
            <label htmlFor="table-search" className="sr-only">
              Qidirish
            </label>
            <div className="relative">
              <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                <svg
                  className="w-4 h-4 text-gray-500 dark:text-gray-400"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 20 20"
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
                  />
                </svg>
              </div>
              <input
                type="text"
                id="table-search-users"
                className="block p-2 pl-10 text-sm text-gray-900 border border-gray-300 rounded-lg w-80 bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                placeholder="Izlash..."
                value={searchTerm}
                onChange={handleSearchChange}
              />
            </div>  
          </div>
          {/* <AddParent /> */}

          <div className="flex items-center gap-4">
          <h1 className="leading-5 text-gray-500 text-xl">Chiqib ketgan o'quvchilar soni</h1>
            <img src={students} className="w-12 h-10 object-cover" alt="" />
            
            <p className="text-4xl">{filteredStaff?.length}</p>
          </div>
        </div>
        {isLoading ? (
          <Loader
            extraClass="col-span-12 flex justify-center"
            Color="#62B238"
          />
        ) : filteredStaff.length > 0 ? (
          <ul className="divide-y-reverse overflow-y-scroll h-[68vh] divide-gray-100 border rounded-lg col-span-12">
            {filteredStaff?.map((parent, index) => (
              <StaffItem parent={parent} index={index} key={parent.id} onStatusChange={refetch} />
            ))}
          </ul>
        ) : (
          <EmptyBox />
        )}
      </div>
    </div>
  );
}

export default React.memo(StudentExit);